"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonDrawer = void 0;

var _drawer = _interopRequireDefault(require("./components/drawer"));

exports.CommonDrawer = _drawer["default"];